import fp from 'lodash/fp';
import React from 'react';
import { Col, Collapse, Row } from 'react-bootstrap';
import { withHandlers } from 'recompose';
import { compose } from 'redux';
import { FormField, Icon } from '..';
import { searchTileTypeFilter } from '../../../constants/content-type';

const ContentTypeFilter = ({
  onContentTypeFilterChange,
  toggleFilterByContentType,
  filterByContentType
}) => (
    <div className='content-type-filter'>
      <Row className='button-gutter'>
        <Col xs={12}>
          <h2
            className='flexbox justify-between'
            type='button'
            onClick={toggleFilterByContentType}
            aria-expanded={filterByContentType}
            aria-controls='filter'>
            Filter by content type
          <Icon icon='minus-large'></Icon>
          </h2>
        </Col>
      </Row>
      <Collapse id="content-type-filter" in={filterByContentType}>
        <form noValidate>
          <fieldset>
            <FormField id='content-type' label='Content type' type='select-item'>
              <select
                id='content-type'
                required
                onChange={(e) => onContentTypeFilterChange(e)}>
                <option value={undefined}></option>
                {
                  fp.flow(
                    fp.keys,
                    fp.map((key) => <option key={key} value={key}>{fp.get(key)(searchTileTypeFilter)}</option>)
                  )(searchTileTypeFilter)
                }
              </select>
            </FormField>
          </fieldset>
        </form>
      </Collapse>
    </div>
  )

export default compose(
  withHandlers({
    onContentTypeFilterChange: ({ updateSelectedContentType }) => (e) => {
      const updatedContentType = fp.get(e.target.value)(searchTileTypeFilter);
      updateSelectedContentType(updatedContentType);
    }
  })
)(ContentTypeFilter)


// WEBPACK FOOTER //
// ./src/containers/components/filters/content-type-filter.js